<template>
  <footer class="bg-white text-gray-mobly54 border-t md:border-0 border-gray-200">
    <div class="bg-gray-moblyFA">
      <div class="container hidden lg:flex mx-auto px-4 py-8">
        <section class="max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          <ul class="col-span-1">
            <li class="pb-4">
              <h3 class="text-lg font-bold mb-2.5">Atendimento</h3>
              <p class="text-sm">
                Está com alguma dúvida ou precisa de ajuda? Conheça nosso atendimento.
              </p>
              <a :href="env.VUE_APP_URL + 'auto-atendimento/'" class="mt-2.5 inline-block hover:text-gray-mobly54 no-underline hover:no-underline">
                <strong>Saiba mais</strong>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 inline-block ml-1">
                  <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
              </a>
            </li>
          </ul>
          <ul class="col-span-1">
            <li class="pb-4">
              <h3 class="text-lg font-bold mb-2.5">Na Mídia</h3>
              <p class="text-sm">
                Fique por dentro do que está rolando e o que a imprensa está falando sobre nós!
              </p>
              <a :href="env.VUE_APP_URL + 'imprensa'" class="mt-2.5 inline-block hover:text-gray-mobly54 no-underline hover:no-underline">
                <strong>Saiba mais</strong>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 inline-block ml-1">
                  <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
              </a>
            </li>
          </ul>
          <ul class="col-span-1">
            <li class="pb-4">
              <h3 class="text-lg font-bold mb-2.5">Trabalhe Conosco</h3>
              <p class="text-sm">
                Somos o maior e-commerce de móveis e objetos de decoração do Brasil. Tá
                interessado em fazer parte do nosso time?
              </p>
              <a :href="env.VUE_APP_URL + 'trabalhe-conosco/'" class="mt-2.5 inline-block hover:text-gray-mobly54 no-underline hover:no-underline">
                <strong>Saiba mais</strong>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 inline-block ml-1">
                  <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
              </a>
            </li>
          </ul>
          <ul class="col-span-1">
            <li class="pb-4">
              <h3 class="text-lg font-bold mb-2.5">Afiliados</h3>
              <p class="text-sm">
                Já pensou em ganhar dinheiro nos divulgando? Torne-se um afiliado e
                aproveite nossas condições especiais.
              </p>
              <a :href="env.VUE_APP_URL + 'programa-afiliados-mobly/'" class="mt-2.5 inline-block hover:text-gray-mobly54 no-underline hover:no-underline">
                <strong>Saiba mais</strong>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 inline-block ml-1">
                  <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
              </a>
            </li>
          </ul>
          <ul class="col-span-1">
            <li class="pb-4">
              <h3 class="text-lg font-bold mb-2.5">Seja um franqueado</h3>
              <p class="text-sm">
                Nossos parceiros estão prontos pra te atender e mostrar todos os
                diferenciais dos produtos e condições Mobly.
              </p>
              <a :href="env.VUE_APP_URL + 'mobly-zip'" class="mt-2.5 inline-block hover:text-gray-mobly54 no-underline hover:no-underline">
                <strong>Saiba mais</strong>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 inline-block ml-1">
                  <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
              </a>
            </li>
          </ul>
        </section>
      </div>
      <div class="container mx-auto px-4 py-8 items-center justify-between">
        <section class="max-w-screen-xl mx-auto flex flex-col xl:flex-row items-center justify-between pb-0 space-y-4 xl:space-y-0">
					<div class="flex flex-col xl:flex-row items-center xl:justify-between space-y-4 xl:space-y-0">
						<div class="font-bold text-2xl mr-2.5 text-nowrap">
							<span>Formas de Pagamento</span>
						</div>
						<ul class="flex flex-wrap items-center mb-0">
							<li>
								<i id="visa" class="bg-mobly-footer-data w-12.5 h-8 block" style="background-position: 2px -50px !important"></i>
							</li>
							<li>
								<i id="mastercard" class="bg-mobly-footer-data w-12.5 h-8 block" style="background-position: -58px -50px !important"></i>
							</li>
							<li>
								<i id="boleto" class="bg-mobly-footer-data w-12.5 h-8 block" style="background-position: -114px -50px !important"></i>
							</li>
							<li>
								<i id="amex" class="bg-mobly-footer-data w-12.5 h-8 block" style="background-position: -175px -50px !important"></i>
							</li>
							<li>
								<i id="dinners" class="bg-mobly-footer-data w-12.5 h-8 block" style="background-position: -234px -50px !important"></i>
							</li>
							<li>
								<i id="hipercard" class="bg-mobly-footer-data w-12.5 h-8 block" style="background-position: -351px -50px !important"></i>
							</li>
							<li>
								<i id="elo" class="bg-mobly-footer-data w-12.5 h-8 block" style="background-position: -2px -90px !important"></i>
							</li>
							<li><img alt="Boleto Flex" width="65px" height="20px" src="https://static.mobly.com.br/cms/marketing/home/2024/payment/geru.png" class="ml-2 mt-1.5 h-5 w-auto"></li>
							<li><img alt="Pix" width="54px" height="36px" src="https://static.mobly.com.br/cms/marketing/checkout/pix_icone_retangular.svg" class="ml-2.5 mr-2.5 h-9 w-auto"></li>
							<li>
								<i id="itau" class="bg-mobly-footer-data w-12.5 h-8 block" style="background-position: -295px -50px !important"></i>
							</li>
						</ul>
					</div>
          <div class="text-right">
            <p class="text-sm">Loja 100% Segura</p>
            <img width="123" height="40" src="https://static.mobly.com.br/cms/marketing/mobly4/icon_rapidssl.png" class="w-auto h-10">
          </div>
        </section>
      </div>
    </div>

		<section class="max-w-screen-xl mx-auto p-4 border-b border-gray-200 divide-y xl:divide-y-0 flex flex-col xl:flex-row justify-center items-center xl:justify-between">
			<div class="flex flex-col xl:flex-row justify-center xl:justify-between items-center w-full xl:w-auto">
				<span class="font-bold text-2xl">Acompanhe-nos</span>
				<ul class="flex flex-wrap items-center">
					<li>
						<a target="_blank" rel="nofollow" href="https://www.facebook.com/MoblyBR" class="inline-flex p-2 hover:text-gray-mobly54 no-underline hover:no-underline">
							<i id="facebook" class="bg-mobly-footer-data bg-no-repeat w-9 h-9"></i>
						</a>
					</li>
					<li>
						<a target="_blank" rel="nofollow" href="https://www.youtube.com/c/Mobilizados" class="inline-flex p-2 hover:text-gray-mobly54 no-underline hover:no-underline">
							<i id="youtube" class="bg-mobly-footer-data w-9 h-9" style="background-position: -40px 0px !important"></i>
						</a>
					</li>
					<li>
						<a target="_blank" rel="nofollow" href="https://www.pinterest.com/mobly/" class="inline-flex p-2 hover:text-gray-mobly54 no-underline hover:no-underline">
						<i id="pinterest" class="bg-mobly-footer-data w-9 h-9" style="background-position: -123px -2px !important;"></i>
						</a>
					</li>
					<li>
						<a target="_blank" rel="nofollow" href="https://instagram.com/mobly/" class="inline-flex p-2 hover:text-gray-mobly54 no-underline hover:no-underline">	
							<i id="instagram" class="bg-mobly-footer-data w-9 h-9" style="background-position: -163px -2px !important"></i>
						</a>
					</li>
					<li>
						<a target="_blank" rel="nofollow" href="https://www.tiktok.com/@mobly" class="inline-flex px-1 hover:text-gray-mobly54 no-underline hover:no-underline">
							<img src="https://static.mobly.com.br/cms/marketing/icon/footer/icon-tiktok.png" class="block h-8 w-8">
						</a>
					</li>
				</ul>
			</div>

			<div class="flex flex-col xl:flex-row justify-center xl:justify-between items-center w-full xl:w-auto">
				<span class="font-bold text-2xl">App mobly</span>
				<ul class="flex justify-center items-center">
					<li>
						<a target="_blank" rel="nofollow" href="https://apps.apple.com/BR/app/id987687565?mt=8" class="inline-flex p-2 hover:text-gray-mobly54 no-underline hover:no-underline">
							<img alt="App Store" width="100" height="30" src="https://static.mobly.com.br/cms/marketing/btn-app-store-footer.jpg" class="h-8 w-auto">
						</a>
					</li>
					<li>
						<a target="_blank" rel="nofollow" href="https://play.google.com/store/apps/details?id=com.mobly" class="inline-flex p-2 hover:text-gray-mobly54 no-underline hover:no-underline">
							<img alt="Google Play" width="100" height="30" src="https://static.mobly.com.br/cms/marketing/btn-app-google-play.jpg" class="h-8 w-auto">
						</a>
					</li>
				</ul>
			</div>
		</section>

		<section class="hidden lg:flex max-w-screen-xl mx-auto px-4 py-4 border-b border-gray-200 text-md font-medium">
			<article>
				<h2 class="text-lg font-bold mb-2">Bem-vindo à Mobly, a sua loja de móveis e artigos de decoração.</h2>
				<br>
				<p class="mb-4">
					A Mobly é uma loja de móveis online que disponibiliza aos seus clientes os
					melhores produtos para casa. São diversos tipos de móveis, artigos de
					decoração, acessórios para casa e muito mais. Aqui você encontra o
					<a :href="env.VUE_APP_URL + 'moveis/sofas/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>sofá</b></a> ideal
					para sua sala, diferentes
					<a :href="env.VUE_APP_URL + 'moveis/guarda-roupas/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>guarda-roupas</b></a>
					para organizar seus pertences, incríveis
					<a :href="env.VUE_APP_URL + 'moveis/poltronas-sala'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>poltronas</b></a>
					para trazer ainda mais conforto para seu ambiente. E o melhor de tudo, são
					diversas peças que combinam com todos os gostos, desde os clássicos aos
					modernos, podendo pagar em até 10x sem juros!
				</p>
				<br>
				<p class="mb-4">
					Temos ofertas em todos os nossos departamentos disponíveis no site e uma
					ampla variedade de produtos, atingindo diferentes necessidades. Então, se
					estiver precisando de uma
					<a :href="env.VUE_APP_URL + 'moveis/camas-tradicionais/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>cama</b></a>
					ou uma
					<a :href="env.VUE_APP_URL + 'moveis-mesas/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>mesa</b></a> nova,
					no departamento de
					<a :href="env.VUE_APP_URL + 'moveis/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Móveis</b></a> você
					encontra uma variedade delas para escolher. Já em
					<a :href="env.VUE_APP_URL + 'infantil/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Infantil</b></a>, temos
					<a :href="env.VUE_APP_URL + 'infantil/bercos/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>berços</b></a> e
					<a :href="env.VUE_APP_URL + 'infantil/camas-infantis/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>camas infantis</b></a>
					muito confortáveis para os pequenos terem uma ótima noite de sono. Agora
					se a ideia é compor a décor do lar com
					<a :href="env.VUE_APP_URL + 'decoracao/quadros/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>quadros</b></a>,
					<a :href="env.VUE_APP_URL + 'decoracao/espelhos-decorativos/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>espelhos</b></a>
					ou
					<a :href="env.VUE_APP_URL + 'decoracao/tapetes/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>tapetes</b></a>, basta navegar por
					<a :href="env.VUE_APP_URL + 'decoracao/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Decoração</b></a>! Mas também não deixe de ver as peças que estão no
					<a :href="env.VUE_APP_URL + 'jardim-e-lazer/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Jardim e Lazer</b></a>,
					<a :href="env.VUE_APP_URL + 'utilidades-domesticas/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Utilidades Domésticas</b></a>
					e <a :href="env.VUE_APP_URL + 'reforma/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Reforma</b></a>. Quem sabe você não encontra o detalhe que faltava?
				</p>
				<br>
				<p class="mb-4">
					Além de oferecer os melhores móveis e artigos para decoração, na Mobly,
					você se mantém atualizado sobre as tendências de design, decoração,
					arquitetura e curiosidades visitando o
					<a :href="env.VUE_APP_URL + 'blog.mobly.com.br/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Blog da Mobly</b></a>. Lá também é possível encontrar dicas para otimizar seu ambiente com
					praticidade e estilo, então, não deixe de acompanhar! Assim como o Blog,
					publicamos conteúdos no site que te ajudam a aproveitar datas importantes
					da melhor maneira, como por exemplo, a
					<a :href="env.VUE_APP_URL + 'black-friday/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Black Friday</b></a>, <a :href="env.VUE_APP_URL + 'natal/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Natal</b></a>,
					<a :href="env.VUE_APP_URL + 'boxing-day/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Boxing Day</b></a> e o
					<a :href="env.VUE_APP_URL + 'dia-do-consumidor/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Dia do Consumidor</b></a>. E indo mais além, também temos dicas e ofertas especiais em comemoração
					ao
					<a :href="env.VUE_APP_URL + 'dia-das-maes/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Dia das Mães</b></a>,
					<a :href="env.VUE_APP_URL + 'dia-das-criancas/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Dia das Crianças</b></a>,
					<a :href="env.VUE_APP_URL + 'dia-dos-pais/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Dia dos Pais</b></a>
					e
					<a :href="env.VUE_APP_URL + 'dia-dos-namorados/'" target="_blank" class="font-bold hover:text-gray-mobly54 no-underline hover:no-underline"><b>Dia dos Namorados</b></a>. A Mobly se preocupa não só com seu lar, como também, com o bem-estar
					das pessoas mais importantes da sua vida!
				</p>
				<br>
				<p class="mb-4">
					Afim de proporcionar uma experiência confiável, a Mobly, conta com
					mecanismos que tornam suas compras mais práticas e seguras. Então, se
					precisar de móveis, decoração e itens para casa, não deixe de nos visitar.
					Estaremos sempre disponíveis para te auxiliar no que for necessário! Nosso
					atendimento tem como objetivo tirar suas dúvidas e fazer com que a sua
					compra seja a melhor, do começo ao fim.
				</p>
				<br>
				<h3 class="text-base font-bold">
					A Mobly agradece a preferência de todos e deseja que seu lar seja mais
					confortável, belo e incrível, assim como os nossos produtos!
				</h3>
				<br>
			</article>
		</section>

		<section class="max-w-screen-xl mx-auto border-b border-gray-200">
			<ul class="mb-0 flex flex-col md:flex-row md:flex-wrap xl:flex-nowrap text-nowrap justify-center text-center">
				<li class="py-3 hover:bg-gray-200"><a :href="env.VUE_APP_URL + 'auto-atendimento'" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Atendimento</a></li>
				<li class="py-3 hover:bg-gray-200"><a :href="env.VUE_APP_URL + 'sobre-a-mobly/'" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Sobre a Mobly</a></li>
				<li class="py-3 hover:bg-gray-200">
					<a href="https://investors.mobly.com.br/" target="_blank" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Investidores</a>
				</li>
				<li class="py-3 hover:bg-gray-200">
					<a :href="env.VUE_APP_URL + 'politica-de-privacidade-mobly'" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Política de Privacidade</a>
				</li>
				<li class="py-3 hover:bg-gray-200"><a :href="env.VUE_APP_URL + 'programa-afiliados-mobly/'" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Afiliados</a></li>
				<li class="py-3 hover:bg-gray-200"><a :href="env.VUE_APP_URL + 'termos-de-uso-mobly'" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Termos de Uso</a></li>
				<li class="py-3 hover:bg-gray-200">
					<a :href="env.VUE_APP_URL + 'torne-se-parceiro-mobly'" class="hover:text-gray-mobly54 no-underline hover:no-underline">Torne-se um Parceiro</a>
				</li>
				<li class="py-3 hover:bg-gray-200"><a :href="env.VUE_APP_URL + 'imprensa/'" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Imprensa</a></li>
				<li class="py-3 hover:bg-gray-200"><a :href="env.VUE_APP_URL + 'mapa-do-site'" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Mapa do Site</a></li>
				<li class="py-3 hover:bg-gray-200"><a :href="env.VUE_APP_URL + 'sitemap.sdex'" class="px-2 py-3 hover:text-gray-mobly54 no-underline hover:no-underline">Mapa de Categorias</a></li>
			</ul>
		</section>

    <section class="hidden lg:block glossary max-w-screen-xl mx-auto px-4 py-4 border-b border-gray-200">
      <ul class="mb-0 flex flex-wrap justify-center text-center">
        <li class="px-1 py-1"><span class="font-bold space-x-2">Glossário</span></li>
        <ul
          v-for="(letter, index) in alphabet"
          :key="letter"
          class="flex items-center justify-center]"
        >
          <li class="hover:bg-gray-200 px-2 rounded-md cursor-pointer">
            <a :href="env.VUE_APP_URL + 'glossario/' + letter" class="hover:text-gray-mobly54 no-underline hover:no-underline">{{ letter }}</a>
          </li>
          <li v-if="index < alphabet.length - 1" class="inline-block">
            <span> • </span>
          </li>
        </ul>
      </ul>
    </section>

		<section class="max-w-screen-xl mx-auto px-4 text-center py-4">
			<p class="mb-1">Mobly Comércio Varejista Ltda. - CNPJ: 14.055.516/0004-90 - Tel.: (11) 4933-0341</p>
			<p class="mb-1">Endereço: Av. das Nações Unidas, 16737 Várzea de Baixo, São Paulo - SP - CEP 04730-090.</p>
			<p class="mt-6">Precisa de ajuda? Conheça nosso atendimento <a :href="env.VUE_APP_URL + 'auto-atendimento'" class="hover:text-gray-mobly54 no-underline hover:no-underline">clicando aqui.</a></p>
		</section>
    <p class="text-center py-4 text-sm"><strong>© 2025 https://www.mobly.com.br. Todos os direitos reservados.</strong></p>
  </footer>
</template>

<script>
export default {
  name: 'StaticFooter',
  data () {
    return {
      alphabet: [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
        'U', 'V', 'W', 'X', 'Y', 'Z'
      ]
    }
  },
  computed: {
    env: function () {
      return process.env
    }
  }
}
</script>
